import SearchCoreModal, { SearchCoreProps } from './SearchCoreModal';
import { Icon, Toast } from 'react-frontier';
import { useEffect, useState } from 'react';
import { WorkerTitle } from '../SiteClasses';
import API from '../API';

interface AvailableWorker{
	worker_id: number,
	worker_name: string,
	zipcode: number,
	city: string,
	rating: number,
	distance: number,
	title_count: number
}

interface SearchAvailableWorkerModalProps extends SearchCoreProps<AvailableWorker>{
	date_id: number
}

var SearchAvailableWorkerModal = (props: SearchAvailableWorkerModalProps)=>{
	var [titles, setTitles] = useState<WorkerTitle[]>([]);
	var [selectedTitle, setSelectedTitle] = useState<number>(null);

	useEffect(() => {
		if (props.open) {
			API.getTitles(100, 0).then(res=>{
				if(res.error) return Toast.error(res.message);
				setTitles(res.data);
			});
		}
	}, [props.open]);

	return <SearchCoreModal
		title='Trabajadores Disponibles'
		{...props}
		size='tiny'
		searchPlaceholder='Buscar trabajadores disponibles...'
		onShowLoad={(query, page, page_size)=>{
			return API.getAvailableWorkers(props.date_id, null, page_size, page * page_size, selectedTitle);
		}}
		searchData={(query, page, page_size)=>{
			return API.getAvailableWorkers(props.date_id, query, page_size, page * page_size, selectedTitle);
		}}
		showFilterButton={true}
		filterOptions={titles.map(t => ({ text: t.title_name, value: t.title_id }))}
		selectedFilter={selectedTitle}
		onFilterChange={(value) => setSelectedTitle(value)}
		pageSize={5}
		table={[
			{ name: 'Trabajador', key: 'worker_name', collapsing: false },
			{ name: 'Distancia', collapsing: true, render: (_, worker) => worker.distance ? `${worker.distance.toFixed(2)} km` : <Icon name='minus' color='gray'/> },
			{ name: 'Rating', centered: true, collapsing: true, render: (_, worker) => 
				worker.rating ? (
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
						<Icon name='star' color='yellow'/>
						<span>
							{parseFloat(worker.rating).toFixed(1)}
						</span>
						{selectedTitle && worker.title_count > 0 && (
							<span style={{ color: 'gray', fontSize: '12px' }}>
								({worker.title_count})
							</span>
						)}
					</div>
				) : (
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
						<Icon name='minus' color='gray'/>
						{selectedTitle && worker.title_count > 0 && (
							<span style={{ color: 'gray', fontSize: '12px' }}>
								({worker.title_count})
							</span>
						)}
					</div>
				)
			}
		]}
	/>
}

export default SearchAvailableWorkerModal;